import React from "react";
import SectionHeading from "./sectionHeading";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const DoctorCondition = ({ content }) => {
  const { title, image = {}, description } = content;

  return (
    <div id="doctorCondition" style={{ backgroundImage: `url(${image.url})` }}>
      <SectionHeading title={title} />
      <div className="paragraphs" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
    </div>
  );
};

export default DoctorCondition;
